import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../stores';
import { FamlaServices } from '../../services';
import { FileText, Calendar } from 'lucide-react';
import { Spiner } from '../../components';
import { useMappingAccessNavigation } from '../../hooks/useMappingAccessNavigation';

interface ReportsModalProps {
}

const ReportsModal = ({ }: ReportsModalProps) => {
    const { t } = useTranslation();
    const users = useAppSelector((state) => state.auth);
    const companyId = users.session.company_id;
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [expandedProcess, setExpandedProcess] = useState<string | null>(null);
    const language = localStorage.getItem('currentLanguage') === 'fr' ? 'fr-FR' : 'en-EN';
    const closeModal = React.useRef<HTMLButtonElement>(null);
    const { openMapping, creditsModal } = useMappingAccessNavigation();

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat(language, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    };

    const handleNavigate = async (processId: string, mapId: string) => {
        const ok = await openMapping({ processId, mapId });
        if (!ok) return;
        closeModal.current?.click();
    };

    const loadGroupedMap = async () => {
        setIsLoading(true);
        try {
            const res = await FamlaServices('api_host', `/mapping/all/mapping/${companyId}`, 'GET', '', users.access_token);
            if (res.status === 200) {
                setData(res.body.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    // console.log("data", companyId);


    useEffect(() => {
        if (companyId) loadGroupedMap();
    }, [companyId]);

    return (
        <>
            {creditsModal}
            <div className="modal" tabIndex={-1} data-bs-backdrop="static" id="reportModal" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dark" role="document">
                <div className="modal-content bg-dark text-light">
                    <div className="modal-header border-secondary">
                        <h1 className="modal-title fs-5">{t('features.swimlane.analysis')}</h1>
                        <button ref={closeModal} type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    {data.length > 0 &&
                        <div className='d-flex align-items-center justify-content-center mt-3'>
                            <p className="text-secondary">{t('features.swimlane.reportsDescription')}</p>
                        </div>
                    }

                    <div className="modal-body border-secondary overflow-auto" style={{ height: "500px" }}>
                        {isLoading ? (
                            <Spiner className="spinner-border-sm" classParent='d-flex justify-content-center' />
                        ) : data.length > 0 ? (
                            <div>
                                {data.map(({ process, map }) => (
                                    <div key={process._id} className="border mb-4 p-4 rounded shadow " >
                                        <h5
                                            className="cursor-pointer text-primary fw-bold"
                                            onClick={() =>
                                                setExpandedProcess((prev) => (prev === process._id ? null : process._id))
                                            }
                                        >
                                            {process.title}
                                        </h5>
                                        {expandedProcess === process._id && (
                                            <ul className="mt-3 list-unstyled">
                                                {map.map((map: any) => (
                                                    <li
                                                        key={map._id}
                                                        className="d-flex justify-content-between align-items-center py-2 border-bottom border-secondary cursor-pointer"
                                                        onClick={() => void handleNavigate(process._id, map._id)}
                                                    >
                                                        <div className="d-flex align-items-center gap-2">
                                                            <FileText size={18} className="text-white" />
                                                            <span>{map.name || ''}</span>
                                                        </div>
                                                        <div className="text-muted small d-flex align-items-center">
                                                            <Calendar size={14} className="me-1" />
                                                            {formatDate(map.created_at)}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="d-flex align-items-center justify-content-center p-4">
                                <div className="d-flex flex-column align-items-center text-center p-4">
                                    <FileText size={48} className="text-secondary mb-3" />
                                    <p className="text-white">{t('features.swimlane.noSavedReports')}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};
export default ReportsModal;